import React from 'react'
import Header from '../../Components/LoginFloder/Header'
import BuilderVerify from '../../Components/Bulider/BuilderVerify'

const BuilderVerifyPage = () => {
  return (
    <div>
        <Header />
        <BuilderVerify />
    </div>
  )
}

export default BuilderVerifyPage